import { defineComponent } from 'vue';
export default defineComponent({
  setup: function setup() {
    return {};
  }
});